import Avatar from './Avatar';
import { GLASS_SURFACES } from '../config/glassSurfaces';

/**
 * @param {{ id: string, display_name?: string | null, profile_photo_url?: string | null, tie?: string }}[] attendees
 */
export default function AttendeeStack({
  attendees = [],
  totalGoing = 0,
  variant = 'large',
  className = '',
}) {
  if (totalGoing === 0) return null;

  const stackMinHeight = 'min-h-[1.5rem]';
  const largeTextInset = variant === 'large' && GLASS_SURFACES.cards ? 'pl-1.5' : '';

  const countText =
    variant === 'hero' ? (
      // No chip scrim on the hero: the venue line above it sits on the photo's own gradient.
      <span className="text-ink/70 text-xs">{totalGoing} going</span>
    ) : (
      <span className="glass-meta-chip text-gray-500 dark:text-ink/70 text-xs">
        {totalGoing} going
      </span>
    );

  if (attendees.length === 0) {
    return (
      <div className={`flex items-center gap-2 ${stackMinHeight} ${className}`}>{countText}</div>
    );
  }

  const shown = attendees.slice(0, 5);

  return (
    <div className={`flex items-center gap-2 ${stackMinHeight} ${largeTextInset} ${className}`}>
      <div className="flex -space-x-2 shrink-0" aria-hidden>
        {shown.map((a, i) => (
          <div
            key={a.id}
            // no ring of its own: each face carries its color ring
            className="relative rounded-full shrink-0"
            style={{ zIndex: i }}
          >
            <Avatar displayName={a.display_name} profilePhotoUrl={a.profile_photo_url} size="xxs" />
          </div>
        ))}
      </div>
      {countText}
    </div>
  );
}
